<template>
  <section>
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-3">
            <img :src="logo" class="custom-logo" />
          </div>
          <div class="col-md-9">
            <span class="custom-name">{{ name }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">{{ hoursOfOperation }}</div>
          <div class="col-md-5">
            <span>phone:</span><span class="ms-2">{{ phone }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <a :href="weburl" target="_blank">{{ weburl }}</a>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            {{ address1 }}
          </div>
          <div class="col-md-12">
            {{ address2 }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">{{ city }}</div>
          <div class="col-md-3">{{ state }}</div>
          <div class="col-md-3">{{ zipcode }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <span class="custom-id-code">#{{ id }}: {{ code }}</span>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'organization-record',
  props: {
    recordData: Object,
  },
  mounted() {
    this.highlightOrganization()
  },
  computed: {
    ...mapGetters('organizations', ['organization']),
    id() {
      let _data = null
      if (this.organization) {
        _data = this.organization.id
      }
      return _data
    },
    code() {
      let _data = null
      if (this.organization) {
        _data = this.organization.orgCode
      }
      return _data
    },
    name() {
      let _data = null
      if (this.organization) {
        _data = this.organization.orgName
      }
      return _data
    },
    logo() {
      let _data = null
      if (this.organization) {
        _data = this.organization.logourl
      }
      return _data
    },
    phone() {
      let _data = null
      if (this.organization) {
        _data = this.organization.phone
      }
      return _data
    },
    weburl() {
      let _data = null
      if (this.organization) {
        _data = this.organization.weburl
      }
      return _data
    },
    address1() {
      let _data = null
      if (this.organization) {
        _data = this.organization.address1
      }
      return _data
    },
    address2() {
      let _data = null
      if (this.organization) {
        _data = this.organization.address2
      }
      return _data
    },
    city() {
      let _data = null
      if (this.organization) {
        _data = this.organization.city
      }
      return _data
    },
    state() {
      let _data = null
      if (this.organization) {
        _data = this.organization.state
      }
      return _data
    },
    zipcode() {
      let _data = null
      if (this.organization) {
        _data = this.organization.zipcode
      }
      return _data
    },
    hoursOfOperation() {
      let _data = null
      if (this.organization) {
        if (
          this.organization.storeDaysOpen !== '' &&
          this.organization.storeDaysClose !== ''
        ) {
          _data = `open: ${this.organization.storeDaysOpen} - ${this.organization.storeDaysClose}`
        }
        if (
          this.organization.storeHoursOpen !== '' &&
          this.organization.storeHoursClose !== ''
        ) {
          if (_data === '') {
            _data = 'open: '
          }
          _data += ` from ${this.organization.storeHoursOpen} to ${this.organization.storeHoursClose}`
        }
      }
      return _data
    },
  },
  methods: {
    ...mapActions('organizations', [
      'examineOrganization',
      'getOrganizationHighlight',
    ]),
    async highlightOrganization() {
      this.examineOrganization({
        id: this.recordData.id,
        name: this.recordData.orgName,
      })
      await this.getOrganizationHighlight(this.recordData.id)
      console.log('Got Organization (highlight)', this.organization)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-name {
  font-size: 1.1em;
  font-weight: 500;
}
.custom-logo {
  max-width: 150px;
}
.custom-id-code {
  font-size: 0.8em;
}
</style>
